<template>
  <div>
    <h2 style="margin-bottom: 16px;">{{ id ? '编辑' : '创建' }}文章/新闻</h2>
    <el-form :model="form" label-width="80px" style="max-width: 720px;">
      <el-form-item label="标题">
        <el-input v-model="form.article_title"></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input type="textarea" :rows="2" v-model="form.article_introduction" placeholder="请输入文章简介"></el-input>
      </el-form-item>
      <el-form-item label="分类">
        <el-radio-group v-model="form.article_lable">
          <el-radio v-for="item in lable" :key="item" :label="item">{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="内容">
        <rich-editor v-model="form.article_content"></rich-editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="$router.push('/admin/articlelist')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import richEditor from '@/components/editor.vue'
import { getLable, createArticle, updateArticle, getArticleDetails } from '@/api'

export default {
  name: 'CreateArticle',
  components: { richEditor },
  props: { id: { type: String, default: '' } },
  data() {
    return {
      lable: [],
      form: { article_title: '', article_introduction: '', article_lable: '', article_content: '' }
    }
  },
  created() {
    getLable('文章分类').then((res) => {
      this.lable = JSON.parse(res.data[0].lable) || []
    })
    if (this.id) {
      getArticleDetails(this.id).then((res) => {
        const d = res.data || {}
        this.form = { article_title: d.article_title, article_introduction: d.article_introduction, article_lable: d.article_lable, article_content: d.article_content }
      })
    }
  },
  methods: {
    onSubmit() {
      if (!this.form.article_title || !this.form.article_lable) {
        this.$message.error('请填写标题和分类')
        return
      }
      if (this.id) {
        updateArticle({ ...this.form, id: this.id }).then((res) => {
          if (res.state.type === 'SUCCESS') {
            this.$message.success('修改成功')
            this.$router.push('/admin/articlelist')
          }
        })
      } else {
        createArticle(this.form).then((res) => {
          if (res.state.type === 'SUCCESS') {
            this.$message.success('发布成功，等待审核')
            this.$router.push('/admin/articlelist')
          }
        })
      }
    }
  }
}
</script>
